export default (name: string) => {
  if (!name) {
    return "";
  }
  return name
    .toLocaleLowerCase()
    .replace(/ /g, "-")
    .replace(/[^a-z0-9-]/g, "");
};
